module.exports = __webpack_public_path__ + "img/mainImg2.00df69a0.jpg";